import React from "react";
import Head from "next/head";

interface HeadProps {
  title: string;
  caption: string;
  image: string;
  url: string;
}

const PageHead = React.forwardRef<Element, HeadProps>(
  ({
     title,
     caption,
     image,
     url,
   }: HeadProps
  ) => {
    return (
      <Head>
        <title>{title}</title>
        <meta name="description" content={caption} />

        {/* Open Graph / Facebook / WhatsApp */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={caption} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={image} />
        <meta property="og:site_name" content="iSudio" />

        {/* Twitter / X */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={caption} />
        <meta name="twitter:image" content={image} />
      </Head>
    )
  }
);

PageHead.displayName = "PageHead";
export {PageHead};